import { render, staticRenderFns } from "./ModalDocumentosRegularidade.vue?vue&type=template&id=3e4cef2b&lang=pug"
import script from "./ModalDocumentosRegularidade.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosRegularidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports